module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-webpack-code-splitting-async-164.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vue-webpack-code-splitting-async.md
// module id = 581
// module chunks = 207